import { render, staticRenderFns } from "./ItDisplay.vue?vue&type=template&id=0570fee2"
import script from "./ItDisplay.vue?vue&type=script&lang=ts"
export * from "./ItDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports